import styled from 'styled-components';
import { DateTime } from 'luxon';
import ReactTooltip from 'react-tooltip';

const Wrapper = styled.div`
`;

const Title = styled.p`
  font-size: 16px;
  font-weight: bold;
  padding-left: 0;
  margin: 0;
  margin-bottom: 16px;
`;

const GridValues = styled.div`
  display: grid;
  grid-template-columns: 150px 150px 1fr;
  row-gap: 16px;
  column-gap: 16px;
`;

const ValueItem = styled.div`
  display: flex;
  flex-direction: column;

  span:first-child {
    font-weight: bold;
  }
`;

function RowDetailView({date, description, area_m2}) {

  return (
    <Wrapper>
      <Title>Additional information</Title>
      <GridValues>
        <ValueItem>
          <span>Date</span>
          <span>{!date ? '-' : DateTime.fromISO(date).toLocaleString({dateStyle: 'short'})}</span>
        </ValueItem>
        <ValueItem>
          <span>Area</span>
          <span>{area_m2}&nbsp;m<sup>2</sup></span>
        </ValueItem>
        <ValueItem>
          <span>Description</span>
          <span>{description || '-'}</span>
        </ValueItem>
      </GridValues>

    </Wrapper>
  );
}

export default RowDetailView;